import React from "react";
import type { FC } from "react";

import { FavouritesDialog, IFavouritesDialogProps } from "../FavouritesDialog";
import messages from "./NoFavouritesDialog.messages";

export const NoFavouritesDialog: FC<IFavouritesDialogProps> = (props) => {
  return (
    <FavouritesDialog title={messages.title} contentText={messages.contentText} actions={[{ name: messages.discardAction }]} {...props} />
  );
};
